// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-radio-group > ion-row {
  gap: 5px;
  margin-bottom: 8px;
}

ion-item {
  --border-width: 0.5px !important;
  --border-radius: 52px !important;
  --border-color: #272727;
  --border-bottom: none;
  border: none;
  margin-top: 0;
}
@media (min-width: 991px) {
  ion-item {
    padding-inline: 3%;
    --min-height: 40px;
  }
}
ion-item:not(:last-child) {
  margin-bottom: 20px;
}
ion-item.no-line {
  --border-color: transparent;
}

@media (min-width: 991px) {
  .form-row {
    zoom: 0.88;
  }
}

ion-input {
  --border: none !important;
  color: var(--color-black);
  font-family: AppFont, sans-serif;
}

.no-line {
  border-bottom: 0px;
  --background: transparent;
}

.privacy {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: var(--ion-color-black);
}
.privacy ion-button {
  padding: 0px;
  color: var(--color-black);
  text-transform: capitalize;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
  font-family: AppFont, sans-serif;
}

ion-item {
  --border-radius: 5px;
  margin-bottom: 0;
}

.terms {
  margin-left: 0px;
}
.terms ion-checkbox {
  margin-right: 10px;
  --checkbox-background-checked: var(--primary-btn);
  font-family: AppFont, sans-serif;
}
.terms ion-checkbox::part(label) {
  white-space: unset;
}
@media (min-width: 991px) {
  .terms {
    padding: 0;
    position: relative;
    bottom: 5px;
  }
}

ion-checkbox {
  margin-left: 0px;
  width: auto;
}

.stacked {
  position: relative;
  top: -10px;
  left: 0%;
  z-index: 2;
}
@media (min-width: 991px) {
  .stacked {
    left: 3%;
  }
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 15px;
  color: var(--color-black);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
@media (max-width: 992px) {
  ion-label {
    font-family: AppFontSemiBold;
    font-size: 14px;
  }
}

@media (min-width: 991px) {
  .name-row {
    padding-inline: 3%;
  }
}

.name-col {
  padding: 0;
}
@media (min-width: 991px) {
  .name-col .stacked {
    left: 0;
  }
  .name-col ion-item {
    padding-inline: 0;
  }
  .name-col:first-child {
    padding-right: 7px;
  }
  .name-col:last-child {
    padding-left: 7px;
  }
}

.input-age ion-input {
  height: 100%;
  text-align: center;
  color: var(--color-black);
}
.input-age ion-input:first-child {
  border-right: 1px solid #cbd5e1;
}
.input-age ion-input:last-child {
  border-left: 1px solid #cbd5e1;
}

ion-footer {
  --background: transparent;
  box-shadow: none;
}

.loading {
  height: 50vh;
  align-items: center;
}

@media (max-width: 992px) {
  .wrapper {
    padding: 50px 15px 20px;
  }
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 20px;
}
.button-wrapper ion-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
@media (min-width: 991px) {
  .button-wrapper ion-button {
    min-height: 64px;
    font-size: 20px;
  }
}
.button-wrapper ion-button p {
  margin-top: 5px;
  font-family: AppFontBold, sans-serif;
  color: white;
  width: 75%;
}

.wrapper-modal {
  border-radius: 26px;
  height: 100%;
  position: relative;
  overflow: auto;
  background: #f6f1ef;
}
@media (max-width: 992px) {
  .wrapper-modal {
    margin-top: 25px;
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    background: #F6F1EF;
    box-shadow: rgba(0, 0, 0, 0.1) -1px -13px 12px;
  }
}
.wrapper-modal ion-item {
  --background: #f6f1ef;
}
.wrapper-modal .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.wrapper-modal .close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper-modal .close-icon:hover {
  background: #f2dbd9;
}
.wrapper-modal .title-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFontMedium, sans-serif;
  font-size: 15px;
  letter-spacing: 0.08em;
}
@media (min-width: 991px) {
  .wrapper-modal .title-text {
    font-family: AppFontBold, sans-serif;
    font-size: 20px;
    margin-bottom: 10px;
    padding-top: 0px;
  }
}
.wrapper-modal .subtitle-text {
  display: none;
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  padding: 10px;
  letter-spacing: 0.08em;
}
@media (min-width: 991px) {
  .wrapper-modal .subtitle-text {
    display: block;
    font-size: 12px;
    padding: 10px;
    margin-bottom: 10px;
  }
}
.wrapper-modal .header-block {
  padding: 20px;
}
@media (min-width: 991px) {
  .wrapper-modal .header-block {
    padding: 20px 40px 5px;
  }
}

.underline {
  --border-width: 0px;
  border: none !important;
  color: var(--primary-btn);
  font-family: AppFont, sans-serif;
}

.error_container {
  margin-bottom: 10px;
}

@media (min-width: 991px) {
  ion-button {
    min-height: 50px !important;
    font-size: 18px !important;
  }
  ion-button:hover {
    --background: var(--primary-btn) !important;
  }
}
.terms_error .input-error {
  position: absolute;
  top: -12px;
}

.input_info {
  position: absolute;
  top: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/sign-up-modal/sign-up-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,6BAAA;AADD;;AAIA;EACC,QAAA;EACA,kBAAA;AADD;;AAGA;EACC,gCAAA;EACA,gCAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;AAAD;ACfE;EDSF;IASE,kBAAA;IACA,kBAAA;EACA;AACF;AACC;EACC,mBAAA;AACF;AAEC;EACC,2BAAA;AAAF;;AC3BE;ED+BF;IAEE,UAAA;EADA;AACF;;AAIA;EACC,yBAAA;EACA,yBAAA;EACA,gCAAA;AADD;;AAGA;EACC,kBAAA;EACA,yBAAA;AAAD;;AAGA;EACC,aAAA;EACA,mBAAA;EAEA,eAAA;EACA,6BAAA;AADD;AAGC;EACC,YAAA;EACA,yBAAA;EACA,0BAAA;AADF;;AAKA;EACC,eAAA;EACA,mBAAA;EACA,gCAAA;AAFD;;AAKA;EACC,oBAAA;EACA,gBAAA;AAFD;;AAKA;EACC,gBAAA;AAFD;AAGC;EACC,kBAAA;EACA,iDAAA;EACA,gCAAA;AADF;AAIC;EACC,kBAAA;AAFF;AC/EE;EDwEF;IAaE,UAAA;IACA,kBAAA;IACA,WAAA;EAFA;AACF;;AAKA;EACC,gBAAA;EACA,WAAA;AAFD;;AAKA;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AAFD;AClGE;EDgGF;IAOE,QAAA;EADA;AACF;;AAGA;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AAAD;ACzGE;EDoGF;IAQE,4BAAA;IACA,eAAA;EACA;AACF;;ACrHE;EDuHF;IAEE,kBAAA;EACA;AACF;;AACA;EACC,UAAA;AAED;AC/HE;ED+HA;IACC,OAAA;EAGD;EADA;IACC,iBAAA;EAGD;EAAA;IACC,kBAAA;EAED;EAAA;IACC,iBAAA;EAED;AACF;;AAEC;EACC,YAAA;EACA,kBAAA;EACA,yBAAA;AACF;AACC;EACC,+BAAA;AACF;AACC;EACC,8BAAA;AACF;;AAEA;EACC,yBAAA;EACA,gBAAA;AACD;;AACA;EACC,YAAA;EACA,mBAAA;AAED;;AC7JE;ED8JF;IAEE,uBAAA;EAEA;AACF;;AACA;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,oBAAA;AAED;AADC;EACC,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;AAEF;ACvLE;EDgLD;IAQE,gBAAA;IACA,eAAA;EAGD;AACF;AAFE;EACC,eAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;AAIH;;AAAA;EAWC,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAPD;ACrME;ED6LF;IAEE,gBAAA;IACA,mBAAA;IACA,8BAAA;IACA,+BAAA;IAEA,mBAAA;IACA,8CAAA;EASA;AACF;AAFC;EACC,qBAAA;AAIF;AAFC;EAEC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAGF;AAFE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAIH;AAFE;EACC,mBAAA;AAIH;AADC;EACC,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;AAGF;ACpPE;ED0OD;IASE,oCAAA;IACA,eAAA;IACA,mBAAA;IACA,gBAAA;EAKD;AACF;AAHC;EACC,aAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;AAKF;ACtQE;EDyPD;IAWE,cAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;EAMD;AACF;AAJC;EACC,aAAA;AAMF;ACjRE;ED0QD;IAGE,sBAAA;EAQD;AACF;;AALA;EACC,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,gCAAA;AAQD;;AANA;EACC,mBAAA;AASD;;ACjSE;ED4RD;IACC,2BAAA;IACA,0BAAA;EASA;EARA;IACC,2CAAA;EAUD;AACF;AANC;EACC,kBAAA;EACA,UAAA;AAQF;;AALA;EACC,kBAAA;EACA,MAAA;AAQD","sourcesContent":["@import '../../../theme/mixins';\n\nion-item.input-error {\n\tmargin-bottom: 8px !important;\n}\n\nion-radio-group > ion-row {\n\tgap: 5px;\n\tmargin-bottom: 8px;\n}\nion-item {\n\t--border-width: 0.5px !important;\n\t--border-radius: 52px !important;\n\t--border-color: #272727;\n\t--border-bottom: none;\n\tborder: none;\n\tmargin-top: 0;\n\n\t@include desktop {\n\t\tpadding-inline: 3%;\n\t\t--min-height: 40px;\n\t}\n\n\t&:not(:last-child) {\n\t\tmargin-bottom: 20px;\n\t}\n\n\t&.no-line {\n\t\t--border-color: transparent;\n\t}\n}\n\n.form-row {\n\t@include desktop {\n\t\tzoom: 0.88;\n\t}\n}\n\nion-input {\n\t--border: none !important;\n\tcolor: var(--color-black);\n\tfont-family: AppFont, sans-serif;\n}\n.no-line {\n\tborder-bottom: 0px;\n\t--background: transparent;\n}\n\n.privacy {\n\tdisplay: flex;\n\talign-items: center;\n\n\tfont-size: 12px;\n\tcolor: var(--ion-color-black);\n\n\tion-button {\n\t\tpadding: 0px;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: capitalize;\n\t}\n}\n\nion-note {\n\tfont-size: 12px;\n\tpadding-right: 10px;\n\tfont-family: AppFont, sans-serif;\n}\n\nion-item {\n\t--border-radius: 5px;\n\tmargin-bottom: 0;\n}\n\n.terms {\n\tmargin-left: 0px;\n\tion-checkbox {\n\t\tmargin-right: 10px;\n\t\t--checkbox-background-checked: var(--primary-btn);\n\t\tfont-family: AppFont, sans-serif;\n\t}\n\n\tion-checkbox::part(label) {\n\t\twhite-space: unset;\n\t}\n\n\t@include desktop {\n\t\tpadding: 0;\n\t\tposition: relative;\n\t\tbottom: 5px;\n\t}\n}\n\nion-checkbox {\n\tmargin-left: 0px;\n\twidth: auto;\n}\n\n.stacked {\n\tposition: relative;\n\ttop: -10px;\n\tleft: 0%;\n\tz-index: 2;\n\n\t@include desktop {\n\t\tleft: 3%;\n\t}\n}\nion-label {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 15px;\n\tcolor: var(--color-black);\n\ttext-transform: uppercase;\n\tletter-spacing: 0.08em;\n\n\t@include mobile {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 14px;\n\t}\n}\n\n.name-row {\n\t@include desktop {\n\t\tpadding-inline: 3%;\n\t}\n}\n.name-col {\n\tpadding: 0;\n\t@include desktop {\n\t\t.stacked {\n\t\t\tleft: 0;\n\t\t}\n\t\tion-item {\n\t\t\tpadding-inline: 0;\n\t\t}\n\n\t\t&:first-child {\n\t\t\tpadding-right: 7px;\n\t\t}\n\t\t&:last-child {\n\t\t\tpadding-left: 7px;\n\t\t}\n\t}\n}\n.input-age {\n\tion-input {\n\t\theight: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t}\n\tion-input:first-child {\n\t\tborder-right: 1px solid #cbd5e1;\n\t}\n\tion-input:last-child {\n\t\tborder-left: 1px solid #cbd5e1;\n\t}\n}\nion-footer {\n\t--background: transparent;\n\tbox-shadow: none;\n}\n.loading {\n\theight: 50vh;\n\talign-items: center;\n}\n\n.wrapper {\n\t@include mobile {\n\t\tpadding: 50px 15px 20px;\n\t}\n}\n\n.button-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tpadding-bottom: 20px;\n\tion-button {\n\t\twidth: 100%;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\n\t\t@include desktop {\n\t\t\tmin-height: 64px;\n\t\t\tfont-size: 20px;\n\t\t}\n\t\tp {\n\t\t\tmargin-top: 5px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tcolor: white;\n\t\t\twidth: 75%;\n\t\t}\n\t}\n}\n.wrapper-modal {\n\t@include mobile {\n\t\tmargin-top: 25px;\n\t\tborder-bottom: none;\n\t\tborder-bottom-left-radius: 0px;\n\t\tborder-bottom-right-radius: 0px;\n\t\t// border: 2px solid var(--color-black);\n\t\tbackground: #F6F1EF;\n\t\tbox-shadow: rgba(0, 0, 0, 0.1) -1px -13px 12px;\n\t}\n\n\tborder-radius: 26px;\n\theight: 100%;\n\tposition: relative;\n\toverflow: auto;\n\tbackground: #f6f1ef;\n\tion-item {\n\t\t--background: #f6f1ef;\n\t}\n\t.close-icon {\n\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t\t&:hover {\n\t\t\tbackground: #f2dbd9;\n\t\t}\n}\n\t.title-text {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tfont-family: AppFontMedium, sans-serif;\n\t\tfont-size: 15px;\n\t\tletter-spacing: 0.08em;\n\t\t@include desktop {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 20px;\n\t\t\tmargin-bottom: 10px;\n\t\t\tpadding-top: 0px;\n\t\t}\n\t}\n\t.subtitle-text {\n\t\tdisplay: none;\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tfont-family: AppFont, sans-serif;\n\t\tpadding: 10px ;\n\t\tletter-spacing: 0.08em;\n\t\t// text-wrap: balance;\n\t\t@include desktop {\n\t\t\tdisplay: block;\n\t\t\tfont-size: 12px;\n\t\t\tpadding:10px;\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\t}\n\t.header-block {\n\t\tpadding: 20px;\n\t\t@include desktop {\n\t\t\tpadding: 20px 40px 5px;\n\t\t}\n\t}\n}\n.underline {\n\t--border-width: 0px;\n\tborder: none !important;\n\tcolor: var(--primary-btn);\n\tfont-family: AppFont, sans-serif;\n}\n.error_container {\n\tmargin-bottom: 10px;\n}\n\n@include desktop {\n\tion-button {\n\t\tmin-height: 50px !important;\n\t\tfont-size: 18px !important;\n\t\t&:hover {\n\t\t\t--background: var(--primary-btn) !important;\n\t\t}\n\t}\n}\n.terms_error {\n\t.input-error{\n\t\tposition: absolute;\n\t\ttop: -12px;\n\t}\n}\n.input_info {\n\tposition: absolute;\n\ttop: 0;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
